module.exports = __webpack_public_path__ + "static/media/primary.bc6955e5.gif";